import { FC } from 'react';

import { useCardOfferDataContext } from 'shared/context/CardContext';
import { useCAForCard } from 'shared/hooks/useCAForCard';
import { stopPropagation } from 'shared/utils/event/stopPropagation';

import { ParentCardLink } from './ParentCardLink';

export const ParentCardLinkContainer: FC = () => {
  const { parentCard } = useCardOfferDataContext();

  const caForCard = useCAForCard();

  if (!parentCard) {
    return null;
  }

  const track = (): void => {
    caForCard({ action: 'click_sopr', category: 'Listing', label: 'to_parent_object' });
  };

  return <ParentCardLink href={parentCard.url} title={parentCard.name} track={track} onClick={stopPropagation} />;
};
